import { LbsContactFormFields } from "@/modules/contacts/LbsContactFormFields";

/** @deprecated Use LbsContactFormFields directly. */
export const ContactInputs = () => <LbsContactFormFields variant="full" />;
